import { format } from 'date-fns';

import { folderContentIcons } from 'modules/dashboard/constants/foldersContentType';
import { translate } from 'hooks/useTranslate';

import { AnalyticsEvent } from '../types/AnalyticsEvent';

export type AnalyticsRow = {
  id: string;
  partnerLabel: string;
  partnerEmail: string;
  actionLabel: string;
  sectionTitle: string;
  folderTitle: string;
  contentTitle: string;
  contentType: string;
  contentIcon: string;
  dateTime: string;
  rawTime: number;
};

const resolveActionLabel = (event: AnalyticsEvent): string => {
  if (event.action === 'contentOpened') return translate('OpenedContent');
  if (event.level === 'folder') return translate('OpenedFolder');
  if (event.level === 'section') return translate('OpenedSection');
  return translate('ViewedLanding');
};

const resolveContentIcon = (contentType?: string): string => {
  if (!contentType) return '';
  const iconMap = folderContentIcons as Record<string, string>;
  return iconMap[contentType] || '';
};

export const formatEventRow = (
  event: AnalyticsEvent,
  index: number
): AnalyticsRow => {
  const safeTime = event.time ? new Date(event.time) : null;
  const dateTime = safeTime ? format(safeTime, 'dd/MM/yyyy HH:mm') : '-';

  return {
    id: `${event.userId || 'anon'}-${event.time || index}-${index}`,
    partnerLabel: event.userName || event.userEmail || '-',
    partnerEmail: event.userEmail || '',
    actionLabel: resolveActionLabel(event),
    sectionTitle: event.sectionTitle || '-',
    folderTitle: event.folderTitle || '-',
    contentTitle: event.contentTitle || '-',
    contentType: event.contentType || '',
    contentIcon: resolveContentIcon(event.contentType),
    dateTime,
    rawTime: event.time || 0,
  };
};

export default formatEventRow;
